const keyCodeMap = {
    37: 'ArrowLeft',
    39: 'ArrowRight',
};

const getKeyCode = (event) => {
    switch (event.key || event.code || keyCodeMap[event.keyCode]) {
        case 'ArrowLeft':
            return 'ArrowLeft';
        case 'ArrowRight':
            return 'ArrowRight';
        default:
            break;
    }
};

const onEnterPressed = (event, callback) => {
    if (event.key === 'Escape') {
        callback();
    }
};

export { getKeyCode, onEnterPressed };
